import { render, staticRenderFns } from "./RealnameUpload.vue?vue&type=template&id=b4561c2a&scoped=true&"
import script from "./RealnameUpload.vue?vue&type=script&lang=js&"
export * from "./RealnameUpload.vue?vue&type=script&lang=js&"
import style0 from "./RealnameUpload.vue?vue&type=style&index=0&id=b4561c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4561c2a",
  null
  
)

export default component.exports